var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 130,
    viewBox: "0 0 94 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_7806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 39.04C6.59721 39.04 8.5 37.1372 8.5 34.79C8.5 32.4428 6.59721 30.54 4.25 30.54C1.90279 30.54 0 32.4428 0 34.79C0 37.1372 1.90279 39.04 4.25 39.04Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.04004C6.59721 9.04004 8.5 7.13725 8.5 4.79004C8.5 2.44283 6.59721 0.540039 4.25 0.540039C1.90279 0.540039 0 2.44283 0 4.79004C0 7.13725 1.90279 9.04004 4.25 9.04004Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 69.04C6.59721 69.04 8.5 67.1372 8.5 64.79C8.5 62.4428 6.59721 60.54 4.25 60.54C1.90279 60.54 0 62.4428 0 64.79C0 67.1372 1.90279 69.04 4.25 69.04Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 129.04C6.59721 129.04 8.5 127.137 8.5 124.79C8.5 122.443 6.59721 120.54 4.25 120.54C1.90279 120.54 0 122.443 0 124.79C0 127.137 1.90279 129.04 4.25 129.04Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 99.04C6.59721 99.04 8.5 97.1372 8.5 94.79C8.5 92.4428 6.59721 90.54 4.25 90.54C1.90279 90.54 0 92.4428 0 94.79C0 97.1372 1.90279 99.04 4.25 99.04Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 38.8601C35.0972 38.8601 37 36.9573 37 34.6101C37 32.2629 35.0972 30.3601 32.75 30.3601C30.4028 30.3601 28.5 32.2629 28.5 34.6101C28.5 36.9573 30.4028 38.8601 32.75 38.8601Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 68.8601C35.0972 68.8601 37 66.9573 37 64.6101C37 62.2629 35.0972 60.3601 32.75 60.3601C30.4028 60.3601 28.5 62.2629 28.5 64.6101C28.5 66.9573 30.4028 68.8601 32.75 68.8601Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 8.86011C35.0972 8.86011 37 6.95732 37 4.61011C37 2.2629 35.0972 0.360107 32.75 0.360107C30.4028 0.360107 28.5 2.2629 28.5 4.61011C28.5 6.95732 30.4028 8.86011 32.75 8.86011Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 128.86C35.0972 128.86 37 126.957 37 124.61C37 122.263 35.0972 120.36 32.75 120.36C30.4028 120.36 28.5 122.263 28.5 124.61C28.5 126.957 30.4028 128.86 32.75 128.86Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.75 98.8601C35.0972 98.8601 37 96.9573 37 94.6101C37 92.2629 35.0972 90.3601 32.75 90.3601C30.4028 90.3601 28.5 92.2629 28.5 94.6101C28.5 96.9573 30.4028 98.8601 32.75 98.8601Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26 128.68C63.6072 128.68 65.51 126.777 65.51 124.43C65.51 122.083 63.6072 120.18 61.26 120.18C58.9128 120.18 57.01 122.083 57.01 124.43C57.01 126.777 58.9128 128.68 61.26 128.68Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26 8.67993C63.6072 8.67993 65.51 6.77714 65.51 4.42993C65.51 2.08272 63.6072 0.179932 61.26 0.179932C58.9128 0.179932 57.01 2.08272 57.01 4.42993C57.01 6.77714 58.9128 8.67993 61.26 8.67993Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26 98.6799C63.6072 98.6799 65.51 96.7771 65.51 94.4299C65.51 92.0827 63.6072 90.1799 61.26 90.1799C58.9128 90.1799 57.01 92.0827 57.01 94.4299C57.01 96.7771 58.9128 98.6799 61.26 98.6799Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26 68.6799C63.6072 68.6799 65.51 66.7771 65.51 64.4299C65.51 62.0827 63.6072 60.1799 61.26 60.1799C58.9128 60.1799 57.01 62.0827 57.01 64.4299C57.01 66.7771 58.9128 68.6799 61.26 68.6799Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.26 38.6799C63.6072 38.6799 65.51 36.7771 65.51 34.4299C65.51 32.0827 63.6072 30.1799 61.26 30.1799C58.9128 30.1799 57.01 32.0827 57.01 34.4299C57.01 36.7771 58.9128 38.6799 61.26 38.6799Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75 38.5C92.0972 38.5 94 36.5972 94 34.25C94 31.9028 92.0972 30 89.75 30C87.4028 30 85.5 31.9028 85.5 34.25C85.5 36.5972 87.4028 38.5 89.75 38.5Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75 8.5C92.0972 8.5 94 6.59721 94 4.25C94 1.90279 92.0972 0 89.75 0C87.4028 0 85.5 1.90279 85.5 4.25C85.5 6.59721 87.4028 8.5 89.75 8.5Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75 98.5C92.0972 98.5 94 96.5972 94 94.25C94 91.9028 92.0972 90 89.75 90C87.4028 90 85.5 91.9028 85.5 94.25C85.5 96.5972 87.4028 98.5 89.75 98.5Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75 68.5C92.0972 68.5 94 66.5972 94 64.25C94 61.9028 92.0972 60 89.75 60C87.4028 60 85.5 61.9028 85.5 64.25C85.5 66.5972 87.4028 68.5 89.75 68.5Z",
    fill: "#729F61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.75 128.5C92.0972 128.5 94 126.597 94 124.25C94 121.903 92.0972 120 89.75 120C87.4028 120 85.5 121.903 85.5 124.25C85.5 126.597 87.4028 128.5 89.75 128.5Z",
    fill: "#729F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_7806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 129.04,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.5905dd631f7aa9261aebe870692c8bf0.svg";
export { ForwardRef as ReactComponent };